import React from 'react'
import './styles/topbar.css';

function TopBar() {
  return (
    <div className='topbar'>
        <h1>Agense Academy</h1>
        <h1>Centre de formation - Abidjan</h1>
    </div>
  )
}

export default TopBar
